import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid
} from '@material-ui/core';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    TableBody,
    TableRow,
    TableCell,
    colors
} from '@material-ui/core';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Available_showrooms from './Available_showrooms';
import Showroom_booking from './Showroom_booking';
import Create_booking from './Create_booking';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3)
    },
    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },

    },

    flexend: {
        justifyContent: 'flex-end',
    }
    // pdTop: {
    //     paddingTop: '30px',
    // }
}));

export default class Dashboard_showroom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            forms: '',
            forms_param: null,
            timeslot_id: null,
            date: null
        };

    }

    create_booking(timeslot_id, date, max_pax) {
        this.setState({
            forms: 'create',
            timeslot_id: timeslot_id,
            date: date,
            max_pax: max_pax
        });
    }
    show_booking(appointment_id) {
        this.setState({ forms: 'info', forms_param: appointment_id });
    }

    create_success(){
        this.setState({
            ...this.state,
            forms: ''
        });
        this.available_showroom.get_data();
    }
    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <div className={clsx(this.props.classes.root, this.props.className)}>
                        <Grid container spacing={1}>
                            <Grid item md={8}>
                                <Available_showrooms
                                    ref={(ref)=> this.available_showroom = ref }
                                    infoAction={this.show_booking.bind(this)}
                                    createAction={this.create_booking.bind(this)}
                                ></Available_showrooms>
                            </Grid>
                            <Grid item md={4}>
                                { 
                                    this.state.forms == 'info' ?
                                        <Showroom_booking
                                            appointment_id={this.state.forms_param}
                                            classes={this.props.classes}></Showroom_booking>
                                        : (this.state.forms == 'create' ?
                                            <Create_booking
                                                successAction={this.create_success.bind(this)}
                                                timeslot_id={this.state.timeslot_id}
                                                max_pax={this.state.max_pax}
                                                date={this.state.date}
                                                classes={this.props.classes}></Create_booking>
                                            : '')
                                }

                            </Grid>
                        </Grid>
                    </div>
                </main>
            </React.Fragment>
        )
    }

}
